import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _COLUMNS, _FEE_TYPES_MAP_API, _FEE_TYPE_TO_STATE_KE, _MS_FEES_TO_FEE_TYPES;

import { INTERNAL_FEE_CODES } from '../../constants/retail/fee.constants';
export var FEE_TYPES = {
  BANK_FEE: 'bankFees',
  DMV_FEE: 'dmvFees',
  OTHER_FEE: 'otherFees',
  LEASE_CONTRACT_FEES: 'leaseContractFees'
};
export var NAME = 'name';
export var AMOUNT = 'amount';
export var MS_AMOUNT = 'marketScanAmt';
export var UPFRONT = 'upfront';
export var TAXABLE = 'taxable';
export var MARKUP = 'markup';
export var COLUMNS = (_COLUMNS = {}, _defineProperty(_COLUMNS, FEE_TYPES.BANK_FEE, [NAME, AMOUNT, MS_AMOUNT, UPFRONT]), _defineProperty(_COLUMNS, FEE_TYPES.OTHER_FEE, [NAME, AMOUNT, MS_AMOUNT, UPFRONT, TAXABLE]), _defineProperty(_COLUMNS, FEE_TYPES.DMV_FEE, [NAME, AMOUNT, MS_AMOUNT, UPFRONT, TAXABLE]), _defineProperty(_COLUMNS, FEE_TYPES.LEASE_CONTRACT_FEES, [NAME, AMOUNT, TAXABLE]), _COLUMNS);
export var BANK = 'BANK';
export var DMV = 'DMV';
export var OTHER = 'OTHER';
export var LEASE_CONTRACT = 'LEASE CONTRACT';
export var FEE_TYPES_MAP_API = (_FEE_TYPES_MAP_API = {}, _defineProperty(_FEE_TYPES_MAP_API, FEE_TYPES.BANK_FEE, BANK), _defineProperty(_FEE_TYPES_MAP_API, FEE_TYPES.DMV_FEE, DMV), _defineProperty(_FEE_TYPES_MAP_API, FEE_TYPES.OTHER_FEE, OTHER), _defineProperty(_FEE_TYPES_MAP_API, FEE_TYPES.LEASE_CONTRACT_FEES, LEASE_CONTRACT), _FEE_TYPES_MAP_API);
export var FILTERS_FOR_FEE_SEARCH = [{
  field: 'active',
  operator: 'IN',
  values: [true]
}, {
  field: 'department',
  operator: 'IN',
  values: ['SALES']
}];
export var REGISTRATION_FEE = 'RegistrationFee';
export var WASTE_TIRE_FEE = 'WasteTireFee';
export var SUPPLEMENTAL_TITLE_FEE = 'SupplementalTitleFee';
export var STATE_FEE = 'StateFee';
export var AQUISITION_FEE = 'Acquisition Fee';
export var LENDERS_AND_MEMBERS_FEE = 'Lenders And Members Fee';
export var COMPONENT_TYPE = {
  TEXT: 'Text',
  DROPDOWN: 'Dropdown'
};
export var FEE_TYPE_TO_STATE_KEY_MAPPER = (_FEE_TYPE_TO_STATE_KE = {}, _defineProperty(_FEE_TYPE_TO_STATE_KE, BANK, FEE_TYPES.BANK_FEE), _defineProperty(_FEE_TYPE_TO_STATE_KE, DMV, FEE_TYPES.DMV_FEE), _defineProperty(_FEE_TYPE_TO_STATE_KE, OTHER, FEE_TYPES.OTHER_FEE), _defineProperty(_FEE_TYPE_TO_STATE_KE, LEASE_CONTRACT, FEE_TYPES.LEASE_CONTRACT_FEES), _FEE_TYPE_TO_STATE_KE);
export var MS_FEES_TO_FEE_TYPES = (_MS_FEES_TO_FEE_TYPES = {}, _defineProperty(_MS_FEES_TO_FEE_TYPES, INTERNAL_FEE_CODES.BANK_OR_ACQUISITION_FEE, BANK), _defineProperty(_MS_FEES_TO_FEE_TYPES, INTERNAL_FEE_CODES.WASTE_TIRE_FEE, OTHER), _defineProperty(_MS_FEES_TO_FEE_TYPES, INTERNAL_FEE_CODES.STATE_FEE, OTHER), _defineProperty(_MS_FEES_TO_FEE_TYPES, INTERNAL_FEE_CODES.TITLE_FEE, OTHER), _defineProperty(_MS_FEES_TO_FEE_TYPES, INTERNAL_FEE_CODES.REGISTRATION_CHARGES, DMV), _defineProperty(_MS_FEES_TO_FEE_TYPES, INTERNAL_FEE_CODES.ENVIRONMENT_PROTECT_FEE, DMV), _MS_FEES_TO_FEE_TYPES);